module.exports = __webpack_public_path__ + "static/media/20_after.4d35a353.jpg";